/** @jsx jsx */
import { Checkbox, jsx, Label, Stack, StackProps } from '@front10/base-elements';
import produce from 'immer';
import { useState } from 'react';

export interface Rule {
  name: string;
  label: string;
  defaultValue: boolean;
}

interface Props {
  options: Array<Rule>;
  defaultValue: Record<string, boolean>;
  onChange?: (newValues: Record<string, boolean>) => void;
}

export function Rules({
  options,
  onChange,
  defaultValue,
  ...props
}: Props & Omit<StackProps, 'children' | 'ref' | 'onChange' | 'defaultValue'>) {
  const [state, setState] = useState(defaultValue);
  return (
    <Stack {...props}>
      {options.map((rule) => (
        <Label
          variant="text.fontSize5"
          key={rule.name}
          sx={{
            color: 'text',
            width: 'unset',
            display: 'inline-flex',
            alignItems: 'center',
          }}
        >
          <Checkbox
            defaultChecked={defaultValue[rule.name]}
            onChange={() => {
              const newState = produce(state, (draft) => {
                draft[rule.name] = !draft[rule.name];
              });
              setState(newState);
              onChange?.(newState);
            }}
          />
          {rule.label}
        </Label>
      ))}
    </Stack>
  );
}
